import React from 'react'

interface FileReviewPopupSuccessProps {
    numComplete: number
}

const FileReviewPopupSuccess = (props: FileReviewPopupSuccessProps) => {
    const { numComplete } = props
    return (
        <div className="info-head">
            <h3>Success!</h3>
            <p>
                You have <span className="bold">{numComplete}</span> work
                {numComplete === 1 ? ' ' : 's '}
                that {numComplete === 1 ? 'is' : 'are'} ready to review and submit.
            </p>
        </div>
    )
}

export default FileReviewPopupSuccess
